import { useState,useEffect} from 'react';
import { DataGrid } from '@mui/x-data-grid';
import { Stack } from '@mui/material'

import SmashBuzzApi from "../api/api.js";

const columns = [
  { field: 'tournamentName', headerName: 'Tournament',
    renderCell: (params: GridCellParams) => {
      return (<a href={params.row.link} target="_blank" rel="noopener noreferrer">{params.row.name}</a>);
    }, flex:.4 },
  { field: 'count', headerName: 'Tweets', type: 'number', flex:.2 },
  { field: 'entrants', headerName: 'Entrants', type: 'number', flex:.2 },
  { field: 'startAt', headerName: 'Date', type: 'date',
    renderCell: (params: GridCellParams) => {
      let date = new Date(params.value*1000);
      return (date.getMonth()+1)+"/"+date.getDate()+"/"+date.getFullYear();
  }, flex:.2 },
];


export default function TourneyTable() {
  const [tourneyData, setTourneyData] = useState([]);

  // get tournament data on mount
  useEffect( () => {
    SmashBuzzApi.getTournaments()
      .then( response => {
        //console.log("Fetched Tournament Data");
        setTourneyData(response);
      })
      .catch( error =>{
        console.log("Error- Could not get tournament data: "+error);
      })
  },[]);

  return (
    <div style={{maxWidth: 800, margin:'auto', display: 'flex'}}>
      <DataGrid autoHeight={true} rows={tourneyData} columns={columns} pageSize={10} rowsPerPageOptions={[10]}
        components={{
          NoRowsOverlay: () => {
            return <Stack>Loading...</Stack>
          }
        }}
      />
    </div>
  );
}
